module.exports = __webpack_public_path__ + "img/logo-company.b485b9a4.png";